import { render } from "./AttachmentType.vue?vue&type=template&id=4a02bdc4"
import script from "./AttachmentType.vue?vue&type=script&lang=js"
export * from "./AttachmentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__